if (window.upsellLogicData) {
  class UpsellLogic {
    constructor() {
      this.load();
    }

    load() {
      const upsellData = window.upsellLogicData;

      const upsellLogic = upsellData.map((item, index) => {
        return {
          id: index+1,
          collectionHandle: item.collectionHandle,
          productId: item.productId,
          variantId: item.variantId || null,
          inCart: item.operator === 'in_cart' ? true : false,
          replace: item.replace,
          heading: item.heading || null,
          description: item.description || null,
          offer: item.offer || null,
          upsellProducts: item.upsellProducts || [],
          upsellVariants: item.upsellVariants || [],
          upsellProductHandles: item.upsellProductHandles || [],
          upsellVariantHandles: item.upsellVariantHandles || []
        };
      });

      localStorage.setItem('upsellLogic', JSON.stringify(upsellLogic));
      window.upsellLogic = upsellLogic;
    }
  }

  new UpsellLogic();
}
